(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cursed-collection-description"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cursed-collection-description')) {
    class CursedCollectionDescription extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const reveal = () => {
          const details = this.querySelector('details');
          if (details) details.open = true;
        };
        const syncHash = () => {
          if (window.location.hash === '#CursedCollectionDescription') reveal();
        };
        document.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const link = event.target.closest('a[href="#CursedCollectionDescription"]');
          if (link) reveal();
        }, options);
        window.addEventListener('hashchange', syncHash, options);
        syncHash();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    }
    customElements.define('cursed-collection-description', CursedCollectionDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
